import { NgRxCustomerReportingLibConfig } from '@usf/ngrx-customer-reporting';
import { environment } from 'src/environments/environment';

export const NG_RX_CUSTOMER_REPORTING_LIB_CONFIG: NgRxCustomerReportingLibConfig =
  {
    apiUrl: environment.customerReportingApiUrl,
  };
